"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningListReturnSchema = exports.LearningPatchSchema = exports.LearningPostSchema = exports.LearningSchema = exports.LearningPaginationSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
const ImpactSchema = zod_1.z.enum(['positive', 'neutral', 'negative', 'unconclusive']);
const ValueSchema = zod_1.z.enum(['surprising', 'expected', 'undefined', 'biaised', 'push_further', 'no_impact']);
exports.LearningPaginationSchema = zod_1.z.object({
    _links: zod_1.z.object({
        _first: zod_1.z.string(),
        _last: zod_1.z.string(),
        _self: zod_1.z.string(),
    }),
    _max_per_page: zod_1.z.number(),
    _page: zod_1.z.number(),
    _pages: zod_1.z.number(),
    _total: zod_1.z.number(),
});
exports.LearningSchema = zod_1.z.object({
    id: zod_1.z.number(),
    value_quality: ValueSchema,
    impact_quality: ImpactSchema,
    details: zod_1.z.string().nullable(),
    test: zod_1.z.object({
        name: zod_1.z.string(),
        test_type: zod_1.z.nativeEnum(types_1.CampaignTypes).nullable(),
        id: zod_1.z.number(),
    }),
});
exports.LearningPostSchema = zod_1.z.object({
    test_id: zod_1.z.number(),
    impact_quality: ImpactSchema,
    value_quality: ValueSchema,
    details: zod_1.z.string().nullable(),
});
exports.LearningPatchSchema = zod_1.z.object({
    learning_id: zod_1.z.number(),
    impact_quality: ImpactSchema,
    value_quality: ValueSchema,
    details: zod_1.z.string().nullable(),
});
exports.LearningListReturnSchema = zod_1.z.object({
    _data: zod_1.z.array(exports.LearningSchema),
    _pagination: exports.LearningPaginationSchema,
});
//# sourceMappingURL=types.js.map